import { render, staticRenderFns } from "./ReturnPassword.vue?vue&type=template&id=269c96c6&scoped=true"
import script from "./ReturnPassword.vue?vue&type=script&lang=js"
export * from "./ReturnPassword.vue?vue&type=script&lang=js"
import style0 from "./ReturnPassword.vue?vue&type=style&index=0&id=269c96c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269c96c6",
  null
  
)

export default component.exports